<template>
  <div class="flex items-center justify-center h-full flex-1">
    <div class="select-none">
      <h1 class="text-center" style="font-size: 160px">404</h1>
      <p class="text-center">{{text}}</p>
    </div>

  </div>
</template>

<script>
  export default {
    name: "ObjectNotFound",
    computed: {
      text(){
        return this.$route.params.text ? this.$route.params.text : "Объект не найден";
      }
    }
  }
</script>